import React from 'react';
import PracticeTestResult from '../../components/PracticeTestResult/PracticeTestResult';

const PracticeTestResultContainer = () => {
  return <PracticeTestResult />;
};

export default PracticeTestResultContainer;
